import React from 'react';
import {Icon} from "antd";

class TabTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {name} = this.props.data;
    if(name.length > 20) {
      name = name.substr(0,17).concat('...');
    }
    return (  <div>
                <span>{name}</span><Icon className={"closeTabBtn"} onClick={() => this.props.deleteTab(this.props.data)} type="close-circle" />
              </div>
    )
  }

}

export default TabTitle;